/*
 * ============================================================================
 * TM Cookies — Gestor de consentimiento de cookies (RGPD) para el tema Warehouse
 * ----------------------------------------------------------------------------
 * - Integra la Customer Privacy API de Shopify (setTrackingConsent / shouldShowBanner).
 * - Implementa Google Consent Mode v2 (update) + Microsoft Clarity (consentv2) + Bing UET.
 * - Los rastreadores de terceros NO se cargan hasta que se concede su categoria.
 * - 4 categorias RGPD: Necesarias (fija), Analitica, Marketing, Preferencias.
 * - Cumplimiento AEPD/CNIL: "Aceptar" y "Rechazar" con la misma prominencia,
 *   sin casillas premarcadas, sin consentimiento implicito, retirada sencilla.
 *
 * Los defaults "denied" de Consent Mode y UET se fijan en snippets/tm-consent-head.liquid
 * (lo primero del <head>). Este fichero solo ACTUALIZA a "granted" tras el consentimiento.
 * ============================================================================
 */
(function () {
  'use strict';

  var ROOT = document.getElementById('tm-cookies');
  if (!ROOT) return;

  // ---- Config inyectada por la seccion (sections/cookie-consent.liquid) ----
  var cfg = {};
  try {
    var cfgEl = document.getElementById('tm-cookies-config');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent || '{}');
  } catch (e) { cfg = {}; }

  var q = function (sel) { return ROOT.querySelector(sel); };

  var els = {
    banner:  q('[data-tmc="banner"]'),
    modal:   q('[data-tmc="modal"]'),
    dialog:  q('[data-tmc="dialog"]'),
    tg: {
      analytics:   q('#tmc-tg-analytics'),
      marketing:   q('#tmc-tg-marketing'),
      preferences: q('#tmc-tg-preferences')
    }
  };

  var loaded = { clarity: false, googleAds: false, bingUet: false };
  var lastFocus = null;
  var decisionStored = false;
  var bannerRequired = false;   // ¿el banner es el punto de entrada legitimo en esta region?
  var openedFromBanner = false; // el modal se abrio desde "Configurar" del banner (capa 1)
  var lastApplied = null;       // dedupe de applyToVendors (self-fire + evento visitorConsentCollected)

  /* ------------------------------------------------------------------ *
   * Cookie propia de primera parte — FUENTE DE VERDAD de la decision.  *
   * Garantiza la persistencia en el navegador con independencia del    *
   * estado de la Customer Privacy API (p.ej. en vista previa o si el   *
   * banner nativo de Shopify convive durante la migracion).            *
   * ------------------------------------------------------------------ */
  var OWN_COOKIE = 'tm_cookie_consent';
  var OWN_COOKIE_DAYS = 182; // ~6 meses (CNIL recomienda 6-13 meses; AEPD max 24)

  function readOwnConsent() {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + OWN_COOKIE + '=([^;]+)'));
    if (!m) return null;
    try {
      var o = JSON.parse(decodeURIComponent(m[1]));
      return (o && typeof o === 'object' && o.v === 1) ? o : null;
    } catch (e) { return null; }
  }

  function writeOwnConsent(analytics, marketing, preferences, vid) {
    var o = { v: 1, vid: vid, analytics: !!analytics, marketing: !!marketing, preferences: !!preferences, ts: Date.now() };
    var exp = new Date(Date.now() + OWN_COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = OWN_COOKIE + '=' + encodeURIComponent(JSON.stringify(o)) +
      '; expires=' + exp + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    return o;
  }

  function makeVid() {
    try {
      var a = new Uint8Array(12);
      (window.crypto || window.msCrypto).getRandomValues(a);
      return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    } catch (e) {
      return 'v' + String(Math.random()).slice(2, 12) + String(Date.now()).slice(-6);
    }
  }

  /* ------------------------------------------------------------------ *
   * Registro de auditoria RGPD (art. 7.1) — best-effort, nunca bloquea. *
   * ------------------------------------------------------------------ */
  function logDecision(action, analytics, marketing, preferences, vid) {
    try {
      var base = String(window.__tmFormsApi || '').replace(/\/+$/, '');
      if (!base) return;
      var payload = JSON.stringify({
        action: action,
        analytics: !!analytics,
        marketing: !!marketing,
        preferences: !!preferences,
        vid: vid || null,
        policy_version: String(cfg.policyVersion || '1'),
        locale: document.documentElement.getAttribute('lang') || '',
        page_url: location.href
      });
      var url = base + '/api/cookie-consent/log';
      // text/plain => peticion "simple" sin preflight CORS; fire-and-forget.
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([payload], { type: 'text/plain' }));
      } else if (window.fetch) {
        fetch(url, { method: 'POST', body: payload, keepalive: true, headers: { 'Content-Type': 'text/plain' } })['catch'](function () {});
      }
    } catch (e) { /* nunca romper el banner por el log */ }
  }

  function gtag() { (window.dataLayer = window.dataLayer || []).push(arguments); }

  /* ------------------------------------------------------------------ *
   * Cargadores de terceros — solo se ejecutan TRAS el consentimiento.  *
   * ------------------------------------------------------------------ */
  function loadClarity() {
    if (loaded.clarity || !cfg.enableClarity || !cfg.clarityId) return;
    loaded.clarity = true;
    (function (c, l, a, r, i) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      var t = l.createElement(r); t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i + '?ref=bwt';
      var y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', cfg.clarityId);
  }

  function loadGoogleAds() {
    if (loaded.googleAds || !cfg.enableGoogleAds || !cfg.googleAdsId) return;
    loaded.googleAds = true;
    // Se preserva el comportamiento original del tema (solo el loader asincrono,
    // sin gtag('config')): Shopify (Google & YouTube channel) aporta la config.
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(cfg.googleAdsId);
    (document.head || document.getElementsByTagName('head')[0]).appendChild(s);
  }

  function loadBingUet() {
    if (loaded.bingUet || !cfg.enableBingUet || !cfg.bingUetId) return;
    loaded.bingUet = true;
    window.uetq = window.uetq || [];
    (function (w, d, t, r, u) {
      var f, n, i, id = cfg.bingUetId;
      w[u] = w[u] || [];
      f = function () { var o = { ti: id, enableAutoSpaTracking: true }; o.q = w[u]; w[u] = new UET(o); w[u].push('pageLoad'); };
      n = d.createElement(t); n.src = r; n.async = 1;
      n.onload = n.onreadystatechange = function () {
        var st = this.readyState;
        if (!st || st === 'loaded' || st === 'complete') { f(); n.onload = n.onreadystatechange = null; }
      };
      i = d.getElementsByTagName(t)[0]; i.parentNode.insertBefore(n, i);
    })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
  }

  /* ------------------------------------------------------------------ *
   * Aplicar el consentimiento a TODOS los proveedores.                 *
   * ------------------------------------------------------------------ */
  function applyToVendors(analytics, marketing) {
    // Dedupe: evita reaplicar el mismo estado (la llamada propia y el evento
    // visitorConsentCollected llegan con los mismos valores; el evento es asincrono).
    var key = (!!analytics) + '|' + (!!marketing);
    if (key === lastApplied) return;
    lastApplied = key;

    // Google Consent Mode v2 — afecta al pixel de Google de Shopify y a lo que carguemos.
    gtag('consent', 'update', {
      'analytics_storage':  analytics ? 'granted' : 'denied',
      'ad_storage':         marketing ? 'granted' : 'denied',
      'ad_user_data':       marketing ? 'granted' : 'denied',
      'ad_personalization': marketing ? 'granted' : 'denied'
    });

    // Microsoft UET (publicidad).
    window.uetq = window.uetq || [];
    window.uetq.push('consent', 'update', { 'ad_storage': marketing ? 'granted' : 'denied' });

    // Cargar los rastreadores permitidos (idempotente).
    if (analytics) loadClarity();
    if (marketing) { loadGoogleAds(); loadBingUet(); }

    // Microsoft Clarity Consent v2 (por si ya estaba cargada). Ojo: claves con S mayuscula.
    if (typeof window.clarity === 'function') {
      window.clarity('consentv2', {
        ad_Storage:        marketing ? 'granted' : 'denied',
        analytics_Storage: analytics ? 'granted' : 'denied'
      });
    }
  }

  /* ------------------------------------------------------------------ *
   * Persistir una decision (unico camino para los 3 botones).          *
   * ------------------------------------------------------------------ */
  function persistConsent(choice, action) {
    var analytics   = !!choice.analytics;
    var marketing   = !!choice.marketing;
    var preferences = !!choice.preferences;

    // 1) Cookie propia — la decision queda guardada en el navegador SIEMPRE,
    //    pase lo que pase con la API de Shopify (visible en DevTools > Cookies).
    var prev = readOwnConsent();
    var vid = (prev && prev.vid) || makeVid();
    writeOwnConsent(analytics, marketing, preferences, vid);
    decisionStored = true;

    // 2) Shopify Customer Privacy API — claves en minusculas + callback.
    try {
      window.Shopify.customerPrivacy.setTrackingConsent(
        { analytics: analytics, marketing: marketing, preferences: preferences, sale_of_data: false },
        function (data) {
          if (data && data.error) console.error('[tm-cookies] setTrackingConsent:', data.error);
        }
      );
    } catch (e) { console.error('[tm-cookies] setTrackingConsent lanzo excepcion', e); }

    // 3) Proveedores (dedupe interno neutraliza el reenvio del evento).
    applyToVendors(analytics, marketing);

    // 4) Registro de auditoria en el dashboard (best-effort).
    logDecision(action || 'custom', analytics, marketing, preferences, vid);

    // 5) Cerrar UI.
    closeModal(true);
    hideBanner();
  }

  /* ------------------------------------------------------------------ *
   * Lectura del consentimiento almacenado.                             *
   * ------------------------------------------------------------------ */
  function currentConsent() {
    try { return window.Shopify.customerPrivacy.currentVisitorConsent() || {}; }
    catch (e) { return {}; }
  }

  // Para replicar a proveedores: '' (sin decidir en region que NO exige consentimiento)
  // se trata como PERMITIDO, para ser coherente con los pixeles de Shopify.
  function consentForVendors() {
    var v = currentConsent();
    var b = function (x) { return x === 'yes' ? true : (x === 'no' ? false : true); };
    return { analytics: b(v.analytics), marketing: b(v.marketing), preferences: b(v.preferences) };
  }

  // Para prerrellenar el modal: primero nuestra cookie; si no, Shopify ('yes' = activado).
  function storedTogglesOn() {
    var own = readOwnConsent();
    if (own) {
      return { analytics: !!own.analytics, marketing: !!own.marketing, preferences: !!own.preferences };
    }
    var v = currentConsent();
    return {
      analytics:   v.analytics === 'yes',
      marketing:   v.marketing === 'yes',
      preferences: v.preferences === 'yes'
    };
  }

  function hasStoredDecision() {
    if (readOwnConsent()) return true; // nuestra cookie manda
    var v = currentConsent();
    return v.analytics === 'yes' || v.analytics === 'no' ||
           v.marketing === 'yes' || v.marketing === 'no' ||
           v.preferences === 'yes' || v.preferences === 'no';
  }

  /* ------------------------------------------------------------------ *
   * UI: banner (capa 1) y modal de preferencias (capa 2).              *
   * ------------------------------------------------------------------ */
  function showBanner() {
    if (!els.banner) return;
    els.banner.setAttribute('aria-hidden', 'false');
  }
  function hideBanner() {
    if (!els.banner) return;
    els.banner.setAttribute('aria-hidden', 'true');
  }

  function setToggles(state) {
    if (els.tg.analytics)   els.tg.analytics.checked   = !!state.analytics;
    if (els.tg.marketing)   els.tg.marketing.checked   = !!state.marketing;
    if (els.tg.preferences) els.tg.preferences.checked = !!state.preferences;
  }

  function openModal() {
    if (!els.modal) return;
    setToggles(storedTogglesOn());
    lastFocus = document.activeElement;
    els.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tmc-lock', 'tmc-modal-open');
    document.addEventListener('keydown', onKeydown, true);
    // Foco al primer control del dialogo.
    var focusable = getFocusable();
    if (focusable.length) focusable[0].focus();
  }

  // fromDecision=true cuando el cierre proviene de guardar una decision.
  function closeModal(fromDecision) {
    if (!els.modal) return;
    els.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tmc-lock', 'tmc-modal-open');
    document.removeEventListener('keydown', onKeydown, true);
    // Si aun no hay decision y el usuario cerro el modal sin guardar, vuelve el banner.
    // El banner NO se puede ocultar sin aceptar/rechazar: si el modal se abrio desde
    // "Configurar" (openedFromBanner) el banner SIEMPRE reaparece al cerrar sin decidir.
    // Desde el enlace del footer solo reaparece si el banner era obligatorio en la region.
    if (!fromDecision && !decisionStored && !hasStoredDecision() && (bannerRequired || openedFromBanner)) showBanner();
    openedFromBanner = false;
    if (lastFocus && typeof lastFocus.focus === 'function') { try { lastFocus.focus(); } catch (e) {} }
  }

  function getFocusable() {
    if (!els.dialog) return [];
    return Array.prototype.slice.call(els.dialog.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      closeModal(false);
      return;
    }
    if (e.key === 'Tab' || e.keyCode === 9) {
      var f = getFocusable();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  /* ------------------------------------------------------------------ *
   * Cableado de eventos de la UI.                                      *
   * ------------------------------------------------------------------ */
  function readModalChoice() {
    return {
      analytics:   !!(els.tg.analytics && els.tg.analytics.checked),
      marketing:   !!(els.tg.marketing && els.tg.marketing.checked),
      preferences: !!(els.tg.preferences && els.tg.preferences.checked)
    };
  }

  function wireUI() {
    ROOT.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-tmc-action]') : null;
      if (!t) return;
      var action = t.getAttribute('data-tmc-action');
      switch (action) {
        case 'accept':
          persistConsent({ analytics: true, marketing: true, preferences: true }, 'accept_all');
          break;
        case 'reject':
          persistConsent({ analytics: false, marketing: false, preferences: false }, 'reject_all');
          break;
        case 'customize':
          openedFromBanner = true;
          hideBanner();
          openModal();
          break;
        case 'save':
          persistConsent(readModalChoice(), 'custom');
          break;
        case 'close-modal':
          closeModal(false);
          break;
      }
    });

    // Clic en el fondo oscuro del modal = cerrar (sin guardar => vuelve el banner si procede).
    if (els.modal) {
      els.modal.addEventListener('click', function (e) {
        if (e.target === els.modal) closeModal(false);
      });
    }
  }

  // Enlaces externos para reabrir preferencias:
  //  - cualquier elemento con [data-tmc-open] (boton propio del footer), o
  //  - cualquier enlace de menu cuya URL contenga "#configurar-cookies".
  function wireExternalOpeners() {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest('[data-tmc-open], a[href*="#configurar-cookies"]')
        : null;
      if (!t) return;
      e.preventDefault();
      hideBanner();
      openModal();
    });
    // Llegada directa con el hash (p. ej. compartir /#configurar-cookies).
    if (location.hash === '#configurar-cookies') {
      hideBanner();
      openModal();
    }
  }

  // API publica para reabrir desde cualquier sitio.
  window.TMCookies = {
    open: function () { hideBanner(); openModal(); },
    showBanner: showBanner
  };

  /* ------------------------------------------------------------------ *
   * Evento oficial de Shopify: mantiene proveedores en sincronia.      *
   * ------------------------------------------------------------------ */
  function wireConsentEvent() {
    document.addEventListener('visitorConsentCollected', function (event) {
      var d = (event && event.detail) || {};
      // El dedupe interno de applyToVendors evita el trabajo redundante tras persistConsent.
      applyToVendors(!!d.analyticsAllowed, !!d.marketingAllowed);
    });
  }

  /* ------------------------------------------------------------------ *
   * Arranque.                                                          *
   * ------------------------------------------------------------------ */
  function init() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    wireUI();
    wireExternalOpeners();
    wireConsentEvent();

    // 1) Nuestra cookie manda: si hay decision guardada en el navegador, no hay
    //    banner y se replica la decision a los proveedores. Persistencia garantizada.
    var own = readOwnConsent();
    if (own) {
      decisionStored = true;
      applyToVendors(!!own.analytics, !!own.marketing);
      return;
    }

    if (!cp) { // API no disponible: mostramos el banner para que el usuario pueda decidir.
      bannerRequired = true;
      showBanner();
      return;
    }

    // 2) Sin cookie propia pero con decision registrada en Shopify (p. ej. tomada
    //    en el banner nativo durante la migracion): no molestamos y replicamos.
    if (hasStoredDecision()) {
      var c0 = currentConsent();
      applyToVendors(c0.analytics === 'yes', c0.marketing === 'yes');
      return;
    }

    var show;
    try { show = cp.shouldShowBanner(); } catch (e) { show = true; }
    if (cfg.forceBanner) show = true;
    bannerRequired = show;

    if (show) {
      setToggles({ analytics: false, marketing: false, preferences: false }); // sin premarcar
      showBanner();
    } else {
      var c = consentForVendors();
      applyToVendors(c.analytics, c.marketing);
    }
  }

  function boot() {
    // Espera a que la Customer Privacy API este disponible via loadFeatures.
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) { console.warn('[tm-cookies] consent-tracking-api no cargo; modo failsafe'); }
        init();
      });
      return;
    }
    // Fallback: reintentar brevemente si window.Shopify aun no existe.
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        clearInterval(iv);
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { init(); });
      } else if (tries > 40) { // ~4s
        clearInterval(iv);
        init(); // failsafe: init sin API (muestra banner)
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
